<template>
  <el-container>
    <el-header height="50px" class="home-header"
      ><div class="admin-div">
        <el-avatar
          size="medium"
          :src="require('@/assets/img/admin-avatar.png')"
        />
        <el-link
          :underline="false"
          style="margin-left: 5px"
          type="primary"
          @click="logout()"
          >登出</el-link
        >
      </div>
    </el-header>
    <el-container>
      <el-aside width="auto" style="float: left">
        <el-menu
          style="height: 100%"
          default-active="1"
          background-color="#f9fafe"
          :collapse="menuCollapse.isCollapse"
          class="el-menu-vertical-demo"
          @mouseenter.native="collapseOpen"
          @mouseleave.native="collapseClose"
        >
          <el-menu-item index="1" @click="routeToVersionIndex">
            <i class="el-icon-setting" />
            <span slot="title">版本管理</span>
          </el-menu-item>
        </el-menu>
      </el-aside>
      <el-main>
        <keep-alive>
          <router-view />
        </keep-alive>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { clearLoginInfo } from "@/utils";
import auth from "@/api/auth";
export default {
  name: "home",
  data() {
    return {
      menuCollapse: {
        collapseBtnClick: false,
        isCollapse: true
      }
    };
  },
  created() {
    this.$router.push({ name: this.$u.routerConst.VERSION_CONTROL_INDEX });
  },
  methods: {
    //注销
    logout() {
      auth.logout().then(() => {
        this.$router.replace({ name: this.$u.routerConst.LOGIN });
        clearLoginInfo();
      });
    },
    collapseOpen() {
      if (this.menuCollapse.collapseBtnClick) return;
      this.menuCollapse.isCollapse = false;
    },
    collapseClose() {
      if (this.menuCollapse.collapseBtnClick) return;
      this.menuCollapse.isCollapse = true;
    },
    //跳转版本控制页
    routeToVersionIndex() {
      this.$router.push({ name: this.$u.routerConst.VERSION_CONTROL_INDEX });
    }
  }
};
</script>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 150px;
}
</style>
<style scoped>
.admin-div {
  margin-top: 0.4rem;
  float: right;
  display: flex;
  justify-content: center;
  height: 40px;
}
.home-header {
  z-index: 100;
  box-shadow: 4px 2px 17px 4px #909399b3;
  background-image: linear-gradient(90deg, #09dc7352 0, #67c23a5e) !important;
}

</style>
